import { render, staticRenderFns } from "./NDVPantalla.vue?vue&type=template&id=51a8f5f9&"
import script from "./NDVPantalla.vue?vue&type=script&lang=ts&"
export * from "./NDVPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports